// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import { useDownloadFile } from '../../useDownloadFile';
import { useRequestPdf } from '../../useRequestPdf';
import t from '../types';

/**
 * Retrieve purchases by items.
 */
export function usePurchasesOrSales(query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.PURCHASES_BY_ITEMS, query],
    {
      method: 'get',
      url: '/financial_statements/purchase-or-sales-report',
      params: query,
    },
    {
      select: (res) => res.data,
      ...props,
    },
  );
}

export function usePurchasesOrSalesTable(query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.PURCHASES_BY_ITEMS, query],
    {
      method: 'get',
      url: '/financial_statements/purchase-or-sales-report',
      params: query,
      headers: {
        accept: 'application/json+table',
      },
    },
    {
      select: (res) => res.data,
      ...props,
    },
  );
}

export const usePurchasesOrSalesCsvExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/purchase-or-sales-report',
    config: {
      headers: {
        accept: 'application/csv',
      },
      params: query,
    },
    filename: 'purchases_by_items.csv',
    ...args,
  });
};

export const usePurchasesOrSalesXlsxExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/purchase-or-sales-report',
    config: {
      headers: {
        accept: 'application/xlsx',
      },
      params: query,
    },
    filename: 'purchases_by_items.xlsx',
    ...args,
  });
};

/**
 * Retrieves the pdf document of purchases by items.
 */
export const usePurchasesOrSalesPdfExport = (query = {}) => {
  return useRequestPdf({
    url: '/financial_statements/purchase-or-sales-report',
    params: query,
  });
};
